import { render, staticRenderFns } from "./SchoolFacialDeviceTeacherModal.vue?vue&type=template&id=d58bde7c&scoped=true&"
import script from "./SchoolFacialDeviceTeacherModal.vue?vue&type=script&lang=js&"
export * from "./SchoolFacialDeviceTeacherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58bde7c",
  null
  
)

export default component.exports